'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.init = init;
exports.cumajorVagueMatch = cumajorVagueMatch;
exports.schoolVagueMatch = schoolVagueMatch;
exports.hiscoreSchoolVagueMatch = hiscoreSchoolVagueMatch;
exports.hiscoreMajorVagueMatch = hiscoreMajorVagueMatch;
exports.hiscoreMajorListVagueMatch = hiscoreMajorListVagueMatch;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelToken = _axios2.default.CancelToken;
var cancel = null;

var t = {
    SEARCH_INIT: 'bp/search/SEARCH_INIT',

    SCH_VAGUE_MATCH: 'bp/search/SCH_VAGUE_MATCH',
    SCH_VAGUE_MATCH_SUCCESS: 'bp/search/SCH_VAGUE_MATCH_SUCCESS',
    SCH_VAGUE_MATCH_FAIL: 'bp/search/SCH_VAGUE_MATCH_FAIL',

    HISCORE_MAJOR_VAGUE_MATCH: 'bp/search/HISCORE_MAJOR_VAGUE_MATCH',
    HISCORE_MAJOR_VAGUE_MATCH_SUCCESS: 'bp/search/HISCORE_MAJOR_VAGUE_MATCH_SUCCESS',
    HISCORE_MAJOR_VAGUE_MATCH_FAIL: 'bp/search/HISCORE_MAJOR_VAGUE_MATCH_FAIL',

    HISCORE_SCH_VAGUE_MATCH: 'bp/search/HISCORE_SCH_VAGUE_MATCH',
    HISCORE_SCH_VAGUE_MATCH_SUCCESS: 'bp/search/HISCORE_SCH_VAGUE_MATCH_SUCCESS',
    HISCORE_SCH_VAGUE_MATCH_FAIL: 'bp/search/HISCORE_SCH_VAGUE_MATCH_FAIL',

    HISCORE_MAJOR_LIST_VAGUE_MATCH: 'bp//search/HISCORE_MAJOR_LIST_VAGUE_MATCH',
    HISCORE_MAJOR_LIST_VAGUE_MATCH_SUCCESS: 'bp//search/HISCORE_MAJOR_LIST_VAGUE_MATCH_SUCCESS',
    HISCORE_MAJOR_LIST_VAGUE_MATCH_FAIL: 'bp//search/HISCORE_MAJOR_LIST_VAGUE_MATCH_FAIL',

    MAJOR_VAGUE_MATCH: 'bp/search/MAJOR_VAGUE_MATCH',
    MAJOR_VAGUE_MATCH_SUCCESS: 'bp/search/MAJOR_VAGUE_MATCH_SUCCESS',
    MAJOR_VAGUE_MATCH_FAIL: 'bp/search/MAJOR_VAGUE_MATCH_FAIL'
};

var initialState = {
    vagueMatchSch: [],
    vagueMatchMajor: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case t.MAJOR_VAGUE_MATCH_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                vagueMatchMajor: action.result.data.data
            });
        case t.SCH_VAGUE_MATCH_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                vagueMatchSch: action.result.data.data
            });
        case t.HISCORE_SCH_VAGUE_MATCH_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                vagueMatchSch: action.result.data.data
            });
        case t.HISCORE_MAJOR_VAGUE_MATCH_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                vagueMatchMajor: action.result.data.data
            });
        case t.HISCORE_MAJOR_LIST_VAGUE_MATCH_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                vagueMatchMajor: action.result.data.data
            });
        case t.SEARCH_INIT:
            return _extends({}, state, {
                vagueMatchSch: [],
                vagueMatchMajor: []
            });
        default:
            return state;
    }
}

function DoCancel(doCancel) {
    if (doCancel) {
        doCancel();
    }
}

function init() {
    return {
        type: t.SEARCH_INIT
    };
}

function cumajorVagueMatch(majorname) {
    DoCancel(cancel);
    return {
        types: [t.MAJOR_VAGUE_MATCH, t.MAJOR_VAGUE_MATCH_SUCCESS, t.MAJOR_VAGUE_MATCH_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/major/search_prompt?key=' + encodeURIComponent(majorname), {
                    cancelToken: new CancelToken(function () {
                        function executor(c) {
                            cancel = c;
                        }

                        return executor;
                    }())
                });
            }

            return promise;
        }()
    };
}

function schoolVagueMatch(schoolname) {
    DoCancel(cancel);
    return {
        types: [t.SCH_VAGUE_MATCH, t.SCH_VAGUE_MATCH_SUCCESS, t.SCH_VAGUE_MATCH_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/cu_school/search_prompt?key=' + encodeURIComponent(schoolname), {
                    cancelToken: new CancelToken(function () {
                        function executor(c) {
                            cancel = c;
                        }

                        return executor;
                    }())
                });
            }

            return promise;
        }()
    };
}

function hiscoreSchoolVagueMatch(schoolname) {
    DoCancel(cancel);
    return {
        types: [t.HISCORE_SCH_VAGUE_MATCH, t.HISCORE_SCH_VAGUE_MATCH_SUCCESS, t.HISCORE_SCH_VAGUE_MATCH_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/bp/hiscore/school/search/prompt?key=' + encodeURIComponent(schoolname), {
                    cancelToken: new CancelToken(function () {
                        function executor(c) {
                            cancel = c;
                        }

                        return executor;
                    }())
                });
            }

            return promise;
        }()
    };
}

function hiscoreMajorVagueMatch(majorname) {
    DoCancel(cancel);
    return {
        types: [t.HISCORE_MAJOR_VAGUE_MATCH, t.HISCORE_MAJOR_VAGUE_MATCH_SUCCESS, t.HISCORE_MAJOR_VAGUE_MATCH_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/bp/hiscore/major/search/prompt?key=' + encodeURIComponent(majorname), {
                    cancelToken: new CancelToken(function () {
                        function executor(c) {
                            cancel = c;
                        }

                        return executor;
                    }())
                });
            }

            return promise;
        }()
    };
}

function hiscoreMajorListVagueMatch(majorname, batchId) {
    DoCancel(cancel);
    return {
        types: [t.HISCORE_MAJOR_LIST_VAGUE_MATCH, t.HISCORE_MAJOR_LIST_VAGUE_MATCH_SUCCESS, t.HISCORE_MAJOR_LIST_VAGUE_MATCH_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/bp/hiscore/rank/major/search/prompt?key=' + encodeURIComponent(majorname) + '&batchId=' + batchId, {
                    cancelToken: new CancelToken(function () {
                        function executor(c) {
                            cancel = c;
                        }

                        return executor;
                    }())
                });
            }

            return promise;
        }()
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/search/search.js
// module id = 463
// module chunks = 0